// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nuevo-requerimiento {
  padding: 32px;
  max-width: 1000px;
  margin: 0 auto;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}

.req-header {
  margin-bottom: 32px;
}

.req-header h2 {
  font-size: 28px;
  font-weight: 800;
  margin: 0 0 8px 0;
  color: #0f172a;
  display: flex;
  align-items: center;
  gap: 12px;
}

[data-theme="dark"] .req-header h2 {
  color: #f8fafc;
}

.stepper-wrapper {
  padding: 24px;
  margin-bottom: 32px;
  position: relative;
}

.stepper-progress-bar {
  position: absolute;
  top: 48px;
  left: 64px;
  right: 64px;
  height: 4px;
  background: #e2e8f0;
  z-index: 1;
  border-radius: 2px;
}

[data-theme="dark"] .stepper-progress-bar {
  background: #334155;
}

.stepper-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #4f46e5, #6366f1);
  transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 2px;
}

.stepper {
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 2;
}

.stepper-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  cursor: pointer;
  flex: 1 1;
}

.stepper-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #f1f5f9;
  border: 2px solid #cbd5e1;
  color: #64748b;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: 16px;
  transition: all 0.3s;
  box-shadow: 0 0 0 4px white;
}

[data-theme="dark"] .stepper-icon {
  background: #1e293b;
  border-color: #475569;
  color: #94a3b8;
  box-shadow: 0 0 0 4px #0f172a;
}

.stepper-item.active .stepper-icon {
  background: #6366f1;
  border-color: #6366f1;
  color: white;
  box-shadow: 0 0 0 4px white, 0 0 15px rgba(99, 102, 241, 0.4);
}

[data-theme="dark"] .stepper-item.active .stepper-icon {
  box-shadow: 0 0 0 4px #0f172a, 0 0 15px rgba(99, 102, 241, 0.4);
}

.stepper-item.completed .stepper-icon {
  background: #10b981;
  border-color: #10b981;
  color: white;
}

.stepper-info {
  margin-top: 12px;
}

.stepper-title {
  display: block;
  font-size: 14px;
  font-weight: 700;
  color: #475569;
}

[data-theme="dark"] .stepper-title {
  color: #cbd5e1;
}

.stepper-item.active .stepper-title {
  color: #6366f1;
}

.stepper-desc {
  display: block;
  font-size: 11px;
  color: #94a3b8;
  margin-top: 2px;
  max-width: 140px;
}

@media (max-width: 768px) {
  .stepper-desc {
    display: none;
  }
  .stepper-progress-bar {
    top: 40px;
  }
  .stepper-icon {
    width: 36px;
    height: 36px;
    font-size: 14px;
  }
}

.form-stepper {
  padding: 40px;
}

.step-header {
  margin-bottom: 32px;
  border-left: 4px solid #6366f1;
  padding-left: 16px;
}

.step-header h3 {
  font-size: 20px;
  font-weight: 700;
  margin: 0 0 6px 0;
  color: #1e293b;
}

[data-theme="dark"] .step-header h3 {
  color: #f1f5f9;
}

.step-header p {
  margin: 0;
  font-size: 14px;
  color: #64748b;
}

[data-theme="dark"] .step-header p {
  color: #94a3b8;
}

.form-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 24px;
  margin-bottom: 20px;
}

.form-row-pricing {
  display: grid;
  grid-template-columns: 1fr 300px;
  gap: 32px;
  align-items: start;
}

@media (max-width: 768px) {
  .form-row-pricing {
    grid-template-columns: 1fr;
  }
}

.bcv-conversion-card {
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.06) 0%, rgba(99, 102, 241, 0.12) 100%);
  border: 1px solid rgba(99, 102, 241, 0.2);
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.bcv-label {
  font-size: 12px;
  font-weight: 600;
  color: #4f46e5;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.bcv-rate {
  font-size: 22px;
  font-weight: 800;
  color: #1e293b;
  font-family: monospace;
}

[data-theme="dark"] .bcv-rate {
  color: #f1f5f9;
}

.bcv-result-label {
  font-size: 11px;
  color: #64748b;
  margin-top: 8px;
  text-transform: uppercase;
}

.bcv-usd-value {
  font-size: 28px;
  font-weight: 800;
  color: #10b981;
  font-family: monospace;
}

.divider {
  border: 0;
  height: 1px;
  background: #e2e8f0;
  margin: 32px 0;
}

[data-theme="dark"] .divider {
  background: #334155;
}

.file-upload-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 24px;
}

.file-upload-card {
  border: 2px dashed #cbd5e1;
  border-radius: 16px;
  padding: 32px 24px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
}

[data-theme="dark"] .file-upload-card {
  border-color: #475569;
}

.file-upload-card:hover {
  border-color: #6366f1;
  background: rgba(99, 102, 241, 0.02);
}

.file-upload-card.has-file {
  border-color: #10b981;
  background: rgba(16, 185, 129, 0.02);
}

.file-upload-icon {
  font-size: 36px;
  margin-bottom: 12px;
}

.file-upload-title {
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 4px;
}

[data-theme="dark"] .file-upload-title {
  color: #f1f5f9;
}

.file-upload-desc {
  font-size: 12px;
  color: #94a3b8;
}

.file-upload-name {
  margin-top: 12px;
  font-size: 13px;
  font-weight: 600;
  color: #10b981;
  background: rgba(16, 185, 129, 0.1);
  padding: 4px 12px;
  border-radius: 9999px;
  max-width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.toggle-group {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  background: rgba(255, 255, 255, 0.4);
  border: 1px solid #e2e8f0;
  padding: 24px;
  border-radius: 16px;
  margin-bottom: 24px;
}

[data-theme="dark"] .toggle-group {
  background: rgba(15, 23, 42, 0.4);
  border-color: #334155;
}

.toggle-container {
  position: relative;
  width: 48px;
  height: 24px;
  flex-shrink: 0;
}

.toggle-container input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: #cbd5e1;
  transition: .3s;
  border-radius: 24px;
}

[data-theme="dark"] .toggle-slider {
  background-color: #475569;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .3s;
  border-radius: 50%;
}

input:checked + .toggle-slider {
  background-color: #6366f1;
}

input:checked + .toggle-slider:before {
  transform: translateX(24px);
}

.toggle-label-info strong {
  display: block;
  font-size: 15px;
  color: #1e293b;
  margin-bottom: 4px;
}

[data-theme="dark"] .toggle-label-info strong {
  color: #f1f5f9;
}

.toggle-label-info p {
  margin: 0;
  font-size: 13px;
  color: #64748b;
}

[data-theme="dark"] .toggle-label-info p {
  color: #94a3b8;
}

.provider-fields {
  margin-top: 24px;
  padding: 24px;
  border: 1px solid #e2e8f0;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 16px;
}

[data-theme="dark"] .provider-fields {
  border-color: #334155;
  background: rgba(15, 23, 42, 0.2);
}

.animate-fade {
  animation: fadeInStep 0.4s ease-out;
}

@keyframes fadeInStep {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Pago Móvil opcional */
.pago-movil-section {
  margin-top: 20px;
  padding: 16px;
  background: rgba(248, 250, 252, 0.8);
  border: 1px dashed #cbd5e1;
  border-radius: 12px;
}

[data-theme="dark"] .pago-movil-section {
  background: rgba(15, 23, 42, 0.3);
  border-color: #334155;
}

.pago-movil-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.pago-movil-header h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: var(--gray-800, #1e293b);
}

[data-theme="dark"] .pago-movil-header h4 {
  color: #e2e8f0;
}

.optional-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  background: #e0f2fe;
  color: #0369a1;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid #bae6fd;
}

[data-theme="dark"] .optional-badge {
  background: rgba(3, 105, 161, 0.2);
  color: #38bdf8;
  border-color: rgba(56, 189, 248, 0.3);
}

.field-optional {
  font-size: 11px;
  font-weight: 400;
  color: #94a3b8;
  margin-left: 4px;
}

.step-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;
  padding-top: 24px;
  border-top: 1px solid #e2e8f0;
}

[data-theme="dark"] .step-footer {
  border-top-color: #334155;
}

.btn {
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-outline {
  background: transparent;
  border: 1px solid #cbd5e1;
  color: #475569;
}

[data-theme="dark"] .btn-outline {
  border-color: #475569;
  color: #cbd5e1;
}

.btn-outline:hover {
  background: #f1f5f9;
}

[data-theme="dark"] .btn-outline:hover {
  background: #1e293b;
}

.step-nav {
  display: flex;
  gap: 16px;
}

.btn-success {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border: none;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);
}

.btn-success:hover {
  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.3);
}

.error-message {
  padding: 16px;
  background: #fef2f2;
  border: 1px solid #fee2e2;
  color: #991b1b;
  border-radius: 12px;
  margin-bottom: 24px;
  font-size: 14px;
  font-weight: 500;
}

.warning-message {
  padding: 16px;
  background: #fffbeb;
  border: 1px solid #fef3c7;
  color: #b45309;
  border-radius: 12px;
  margin-bottom: 24px;
  font-size: 14px;
  font-weight: 500;
}

.field-hint.warning {
  margin-top: 8px;
  font-size: 12px;
  color: #b45309;
}

/* =========================================
   RESPONSIVE DESIGN (Tablets y Móviles)
   Añadido sin romper el diseño de escritorio
   ========================================= */

@media (max-width: 768px) {
  .nuevo-requerimiento {
    padding: 16px;
  }
  
  .form-stepper {
    padding: 20px;
  }
  
  .step-footer {
    flex-direction: column;
    gap: 16px;
  }
  
  .step-nav {
    width: 100%;
    flex-direction: column;
  }
  
  .step-nav .btn {
    width: 100%;
  }
  
  .btn-outline {
    width: 100%;
    text-align: center;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/NuevoRequerimiento.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,mEAAmE;AACrE;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,mDAAmD;EACnD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,6DAA6D;AAC/D;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,+FAA+F;EAC/F,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,oCAAoC;EACpC,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,aAAa;EACb,oCAAoC;EACpC,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;;;8CAG8C;;AAE9C;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF","sourcesContent":[".nuevo-requerimiento {\n  padding: 32px;\n  max-width: 1000px;\n  margin: 0 auto;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.req-header {\n  margin-bottom: 32px;\n}\n\n.req-header h2 {\n  font-size: 28px;\n  font-weight: 800;\n  margin: 0 0 8px 0;\n  color: #0f172a;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n[data-theme=\"dark\"] .req-header h2 {\n  color: #f8fafc;\n}\n\n.stepper-wrapper {\n  padding: 24px;\n  margin-bottom: 32px;\n  position: relative;\n}\n\n.stepper-progress-bar {\n  position: absolute;\n  top: 48px;\n  left: 64px;\n  right: 64px;\n  height: 4px;\n  background: #e2e8f0;\n  z-index: 1;\n  border-radius: 2px;\n}\n\n[data-theme=\"dark\"] .stepper-progress-bar {\n  background: #334155;\n}\n\n.stepper-progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #4f46e5, #6366f1);\n  transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  border-radius: 2px;\n}\n\n.stepper {\n  display: flex;\n  justify-content: space-between;\n  position: relative;\n  z-index: 2;\n}\n\n.stepper-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  cursor: pointer;\n  flex: 1;\n}\n\n.stepper-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: #f1f5f9;\n  border: 2px solid #cbd5e1;\n  color: #64748b;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 700;\n  font-size: 16px;\n  transition: all 0.3s;\n  box-shadow: 0 0 0 4px white;\n}\n\n[data-theme=\"dark\"] .stepper-icon {\n  background: #1e293b;\n  border-color: #475569;\n  color: #94a3b8;\n  box-shadow: 0 0 0 4px #0f172a;\n}\n\n.stepper-item.active .stepper-icon {\n  background: #6366f1;\n  border-color: #6366f1;\n  color: white;\n  box-shadow: 0 0 0 4px white, 0 0 15px rgba(99, 102, 241, 0.4);\n}\n\n[data-theme=\"dark\"] .stepper-item.active .stepper-icon {\n  box-shadow: 0 0 0 4px #0f172a, 0 0 15px rgba(99, 102, 241, 0.4);\n}\n\n.stepper-item.completed .stepper-icon {\n  background: #10b981;\n  border-color: #10b981;\n  color: white;\n}\n\n.stepper-info {\n  margin-top: 12px;\n}\n\n.stepper-title {\n  display: block;\n  font-size: 14px;\n  font-weight: 700;\n  color: #475569;\n}\n\n[data-theme=\"dark\"] .stepper-title {\n  color: #cbd5e1;\n}\n\n.stepper-item.active .stepper-title {\n  color: #6366f1;\n}\n\n.stepper-desc {\n  display: block;\n  font-size: 11px;\n  color: #94a3b8;\n  margin-top: 2px;\n  max-width: 140px;\n}\n\n@media (max-width: 768px) {\n  .stepper-desc {\n    display: none;\n  }\n  .stepper-progress-bar {\n    top: 40px;\n  }\n  .stepper-icon {\n    width: 36px;\n    height: 36px;\n    font-size: 14px;\n  }\n}\n\n.form-stepper {\n  padding: 40px;\n}\n\n.step-header {\n  margin-bottom: 32px;\n  border-left: 4px solid #6366f1;\n  padding-left: 16px;\n}\n\n.step-header h3 {\n  font-size: 20px;\n  font-weight: 700;\n  margin: 0 0 6px 0;\n  color: #1e293b;\n}\n\n[data-theme=\"dark\"] .step-header h3 {\n  color: #f1f5f9;\n}\n\n.step-header p {\n  margin: 0;\n  font-size: 14px;\n  color: #64748b;\n}\n\n[data-theme=\"dark\"] .step-header p {\n  color: #94a3b8;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 24px;\n  margin-bottom: 20px;\n}\n\n.form-row-pricing {\n  display: grid;\n  grid-template-columns: 1fr 300px;\n  gap: 32px;\n  align-items: start;\n}\n\n@media (max-width: 768px) {\n  .form-row-pricing {\n    grid-template-columns: 1fr;\n  }\n}\n\n.bcv-conversion-card {\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.06) 0%, rgba(99, 102, 241, 0.12) 100%);\n  border: 1px solid rgba(99, 102, 241, 0.2);\n  border-radius: 16px;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.bcv-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #4f46e5;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.bcv-rate {\n  font-size: 22px;\n  font-weight: 800;\n  color: #1e293b;\n  font-family: monospace;\n}\n\n[data-theme=\"dark\"] .bcv-rate {\n  color: #f1f5f9;\n}\n\n.bcv-result-label {\n  font-size: 11px;\n  color: #64748b;\n  margin-top: 8px;\n  text-transform: uppercase;\n}\n\n.bcv-usd-value {\n  font-size: 28px;\n  font-weight: 800;\n  color: #10b981;\n  font-family: monospace;\n}\n\n.divider {\n  border: 0;\n  height: 1px;\n  background: #e2e8f0;\n  margin: 32px 0;\n}\n\n[data-theme=\"dark\"] .divider {\n  background: #334155;\n}\n\n.file-upload-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 24px;\n}\n\n.file-upload-card {\n  border: 2px dashed #cbd5e1;\n  border-radius: 16px;\n  padding: 32px 24px;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n[data-theme=\"dark\"] .file-upload-card {\n  border-color: #475569;\n}\n\n.file-upload-card:hover {\n  border-color: #6366f1;\n  background: rgba(99, 102, 241, 0.02);\n}\n\n.file-upload-card.has-file {\n  border-color: #10b981;\n  background: rgba(16, 185, 129, 0.02);\n}\n\n.file-upload-icon {\n  font-size: 36px;\n  margin-bottom: 12px;\n}\n\n.file-upload-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #1e293b;\n  margin-bottom: 4px;\n}\n\n[data-theme=\"dark\"] .file-upload-title {\n  color: #f1f5f9;\n}\n\n.file-upload-desc {\n  font-size: 12px;\n  color: #94a3b8;\n}\n\n.file-upload-name {\n  margin-top: 12px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #10b981;\n  background: rgba(16, 185, 129, 0.1);\n  padding: 4px 12px;\n  border-radius: 9999px;\n  max-width: 90%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.toggle-group {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  background: rgba(255, 255, 255, 0.4);\n  border: 1px solid #e2e8f0;\n  padding: 24px;\n  border-radius: 16px;\n  margin-bottom: 24px;\n}\n\n[data-theme=\"dark\"] .toggle-group {\n  background: rgba(15, 23, 42, 0.4);\n  border-color: #334155;\n}\n\n.toggle-container {\n  position: relative;\n  width: 48px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n.toggle-container input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.toggle-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background-color: #cbd5e1;\n  transition: .3s;\n  border-radius: 24px;\n}\n\n[data-theme=\"dark\"] .toggle-slider {\n  background-color: #475569;\n}\n\n.toggle-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: .3s;\n  border-radius: 50%;\n}\n\ninput:checked + .toggle-slider {\n  background-color: #6366f1;\n}\n\ninput:checked + .toggle-slider:before {\n  transform: translateX(24px);\n}\n\n.toggle-label-info strong {\n  display: block;\n  font-size: 15px;\n  color: #1e293b;\n  margin-bottom: 4px;\n}\n\n[data-theme=\"dark\"] .toggle-label-info strong {\n  color: #f1f5f9;\n}\n\n.toggle-label-info p {\n  margin: 0;\n  font-size: 13px;\n  color: #64748b;\n}\n\n[data-theme=\"dark\"] .toggle-label-info p {\n  color: #94a3b8;\n}\n\n.provider-fields {\n  margin-top: 24px;\n  padding: 24px;\n  border: 1px solid #e2e8f0;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 16px;\n}\n\n[data-theme=\"dark\"] .provider-fields {\n  border-color: #334155;\n  background: rgba(15, 23, 42, 0.2);\n}\n\n.animate-fade {\n  animation: fadeInStep 0.4s ease-out;\n}\n\n@keyframes fadeInStep {\n  from { opacity: 0; transform: translateY(10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* Pago Móvil opcional */\n.pago-movil-section {\n  margin-top: 20px;\n  padding: 16px;\n  background: rgba(248, 250, 252, 0.8);\n  border: 1px dashed #cbd5e1;\n  border-radius: 12px;\n}\n\n[data-theme=\"dark\"] .pago-movil-section {\n  background: rgba(15, 23, 42, 0.3);\n  border-color: #334155;\n}\n\n.pago-movil-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n\n.pago-movil-header h4 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--gray-800, #1e293b);\n}\n\n[data-theme=\"dark\"] .pago-movil-header h4 {\n  color: #e2e8f0;\n}\n\n.optional-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 10px;\n  background: #e0f2fe;\n  color: #0369a1;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 500;\n  border: 1px solid #bae6fd;\n}\n\n[data-theme=\"dark\"] .optional-badge {\n  background: rgba(3, 105, 161, 0.2);\n  color: #38bdf8;\n  border-color: rgba(56, 189, 248, 0.3);\n}\n\n.field-optional {\n  font-size: 11px;\n  font-weight: 400;\n  color: #94a3b8;\n  margin-left: 4px;\n}\n\n.step-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 40px;\n  padding-top: 24px;\n  border-top: 1px solid #e2e8f0;\n}\n\n[data-theme=\"dark\"] .step-footer {\n  border-top-color: #334155;\n}\n\n.btn {\n  padding: 12px 24px;\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-outline {\n  background: transparent;\n  border: 1px solid #cbd5e1;\n  color: #475569;\n}\n\n[data-theme=\"dark\"] .btn-outline {\n  border-color: #475569;\n  color: #cbd5e1;\n}\n\n.btn-outline:hover {\n  background: #f1f5f9;\n}\n\n[data-theme=\"dark\"] .btn-outline:hover {\n  background: #1e293b;\n}\n\n.step-nav {\n  display: flex;\n  gap: 16px;\n}\n\n.btn-success {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  border: none;\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);\n}\n\n.btn-success:hover {\n  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.3);\n}\n\n.error-message {\n  padding: 16px;\n  background: #fef2f2;\n  border: 1px solid #fee2e2;\n  color: #991b1b;\n  border-radius: 12px;\n  margin-bottom: 24px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.warning-message {\n  padding: 16px;\n  background: #fffbeb;\n  border: 1px solid #fef3c7;\n  color: #b45309;\n  border-radius: 12px;\n  margin-bottom: 24px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.field-hint.warning {\n  margin-top: 8px;\n  font-size: 12px;\n  color: #b45309;\n}\n\n/* =========================================\n   RESPONSIVE DESIGN (Tablets y Móviles)\n   Añadido sin romper el diseño de escritorio\n   ========================================= */\n\n@media (max-width: 768px) {\n  .nuevo-requerimiento {\n    padding: 16px;\n  }\n  \n  .form-stepper {\n    padding: 20px;\n  }\n  \n  .step-footer {\n    flex-direction: column;\n    gap: 16px;\n  }\n  \n  .step-nav {\n    width: 100%;\n    flex-direction: column;\n  }\n  \n  .step-nav .btn {\n    width: 100%;\n  }\n  \n  .btn-outline {\n    width: 100%;\n    text-align: center;\n  }\n}\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
